import React from "react";
import PropTypes from "prop-types";
import { TextField } from "@mui/material";
import UpperCaseText from "../../../utils/UpperCaseText";

const EMPInputField = React.forwardRef((props, ref) => {
  const {
    type,
    placeholder,
    validationState,
    value,
    testId,
    disabled,
    readOnly,
    error,
    onChange,
    onClick,
    name,
    multiline,
    helperText,
    startAdornment,
  } = props;

  return (
    <TextField
      InputProps={{
        readOnly,
        disableUnderline: true,
        startAdornment,
      }}
      inputProps={{
        "data-testid": testId,
      }}
      type={type}
      value={value}
      error={UpperCaseText(validationState) === "ERROR" || error}
      color={
        UpperCaseText(validationState) === "SUCCESS" ? "secondary" : "primary"
      }
      FormHelperTextProps={{
        error: UpperCaseText(validationState) === "ERROR" || error,
      }}
      placeholder={placeholder}
      fullWidth
      disabled={disabled}
      onChange={onChange}
      onClick={onClick}
      ref={ref}
      name={name}
      multiline={multiline}
      helperText={helperText}
      variant="standard"
    ></TextField>
  );
});

EMPInputField.displayName = "EMPInputField";

EMPInputField.propTypes = {
  type: PropTypes.string,
  placeholder: PropTypes.string,
  validationState: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  testId: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  error: PropTypes.bool,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  name: PropTypes.string,
  multiline: PropTypes.bool,
  helperText: PropTypes.node,
  startAdornment: PropTypes.node,
};

export default EMPInputField;
